var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    MenuItem.prototype.render = function () {
        return null;
    };
    /**
     * @hidden
     */
    MenuItem.propTypes = {
        text: PropTypes.string,
        url: PropTypes.string,
        icon: PropTypes.string,
        disabled: PropTypes.bool,
        cssClass: PropTypes.string,
        cssStyle: PropTypes.object,
        render: PropTypes.any,
        linkRender: PropTypes.any,
        contentRender: PropTypes.any,
        data: PropTypes.any
    };
    return MenuItem;
}(React.Component));
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map